// ----------------------------------------------------------------------

export default function Table(theme) {
    return {
        MuiTableCell: {
            styleOverrides: {
                root: {
                    "borderColor": theme.palette.divider,
                },
                head: {
                    color: theme.palette.text.secondary,
                    backgroundColor: theme.palette.background.neutral
                }
            }
        },
        // mui-selected
        MuiTableRow: {
            styleOverrides: {
                root: {
                    "backgroundColor": theme.palette.background.default,
                    '&.Mui-selected': {
                        "backgroundColor": theme.palette.action.selected,
                        '&:hover': {
                            backgroundColor: theme.palette.action.hover
                        }
                    }
                }
            }
        },
    };
}
